require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-issues-facing-tech-industry-diversity.json") })
        }
      }, "path---blog-issues-facing-tech-industry-diversity");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-issues-facing-tech-industry-diversity!./.cache/json/blog-issues-facing-tech-industry-diversity.json
// module id = 893
// module chunks = 231608221292675